import React from "react";
import ReactModal from "react-modal";

function AchievementItem({
  title,
  by,
  date,
  imageUrl,
  description,
  additionalImage,
}) {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function setImage() {
    if (additionalImage !== "") {
      return (
        <img
          className="image"
          src={additionalImage}
          srcSet={additionalImage}
          style={{ width: "100%", height: "auto" }}
          alt=""
        />
      );
    }
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <li>
      <div className="list_inner" onClick={openModal}>
        <div className="image">
          <div
            className="main"
            style={{
              backgroundImage: "url(" + imageUrl + ")",
            }}></div>
        </div>
        <div className="details">
          <div className="extra">
            <p className="date">
              By <a href="/">{by}</a>
              <span>{date}</span>
            </p>
          </div>
          <h3 className="title">{title}</h3>
          <div className="tokyo_tm_read_more">
            <div className="read-more">
              <span>Read More</span>
            </div>
          </div>
        </div>
      </div>
      <ReactModal
        className="mymodal"
        overlayClassName="myoverlay"
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal">
        <div className="tokyo_tm_modalbox_news">
          <button className="close-modal" onClick={closeModal}>
            <img
              src="https://tokyo-nextjs.vercel.app/img/svg/cancel.svg"
              alt="close icon"
            />
          </button>
          <div className="box_inner">
            <div className="description_wrap scrollable">
              <div className="image">
                <div
                  className="main"
                  style={{
                    backgroundImage: "url(" + imageUrl + ")",
                  }}></div>
              </div>
              <div className="details">
                <div className="extra">
                  <p className="date">
                    By <a href="/">{by}</a>
                    <span>{date}</span>
                  </p>
                </div>
                <h3 className="title">{title}</h3>
              </div>
              <div className="main_content ">
                <div className="descriptions">{description}</div>
                {setImage()}
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </li>
  );
}

export default AchievementItem;
